module.exports = __webpack_public_path__ + "files/9c17430457e2c00260d4b79d44cb774a.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/sourcesanspro-italic-webfont.woff2
 ** module id = 1023
 ** module chunks = 0
 **/